import { HOUR, MOMENT_DAY, MONTH } from 'consts';
import NotAuthorizedError from 'errors/notAuthorizedError';
import moment from 'moment';

export const DEFAULT_PAGINATION_PAGE_SIZE = {
  pageNum: 1,
  pageSize: 20,
};

export const defaultWidgetFilters = (filters, type, showDetails) => (
  {
    kpiListSearch: type,
    showDetails,
    dateFrom: filters ? filters.find((obj) => obj.type === 'dateFrom')?.value : null,
    dateTo: filters ? filters.find((obj) => obj.type === 'dateTo')?.value : null,
  }
);

export const getDefaultTimeOptionsMapper = (currentTimeZone) => {
  const today = moment.tz(currentTimeZone);
  return {
    currentMonth: [today.clone().startOf(MONTH).toDate(), today.clone().startOf('day').toDate()],
    last3months: [today.clone().subtract(3, 'month').toDate(), today.clone().startOf('day').toDate()],
    past6months: [today.clone().subtract(6, 'month').toDate(), today.clone().startOf('day').toDate()],
  };
};

/**
 *
 * @param {Array} filters - Array of filters returned by MainSearchBar ,
 * @param { {[key: string]: string} } mapper - Mapper for each field
 * @returns  {Array} array of filters mapped in this format {type:'val': value: 'val'}
 */

// TODO AFTER REFACTORS THE MAPPER PARAMETER SHOUL BE REMOVED
export const generalSearchBarFetchFilterFormatter = (
  filters, mapper = {}, currentTimeZone,
) => (filters?.length ? filters.reduce((acc, { id, value }) => {
  let toRet = {};
  if (id === 'timeFilter') {
    // if it is a multidate component, split the array in 2. arr[0] = date start, arr[1] = date end
    const val = typeof value === 'string' ? getDefaultTimeOptionsMapper(currentTimeZone)[value] : value;
    val.forEach((time, index) => {
      toRet = {
        ...toRet,
        [index === 0
          ? ('startRange') // see *1
          : ('endRange')]: moment(time).tz('Europe/Rome').format('YYYY-MM-DD'), // TBR when adopted dynamic TimeZone
      };
    });
  } else {
    toRet = {
      ...toRet,
      [mapper[id] || id]: value?.value ?? value,
    };
  }

  return {
    ...acc,
    ...toRet,
  };
}, {}) : {});

export const filtersNormalizer = (filters) => filters?.reduce((prev, acc) => ({ ...prev, [acc.type]: acc.value }), {});

export const filterObjForSearchBar = (
  filters, mapper = {},
) => {
  const filterArray = generalSearchBarFetchFilterFormatter(
    filters, mapper,
  );
  return filtersNormalizer(filterArray);
};

export const clearTimeoutAutocomplete = (searchTypo, setActivate) => {
  if (!searchTypo || searchTypo.length < 3) {
    return null;
  }
  const timer = setTimeout(() => {
    if (setActivate) setActivate(true);
  }, 3000);
  return () => {
    clearTimeout(timer);
  };
};

export const granularityOptions = (t, isDateDiffUnder30Days) => {
  const options = [
    {
      label: t('widgets.day'),
      value: MOMENT_DAY,
    },
    {
      label: t('widgets.month'),
      value: MONTH,
    },
  ];

  if (isDateDiffUnder30Days) {
    options.unshift({
      label: t('widgets.hour'),
      value: HOUR,
    });
  }
  return options;
};

export const dataTypeOptions = (t) => [
  {
    label: t('widgets.all'),
    value: 'all',
  },
  {
    label: t('widgets.certified'),
    value: 'CERTIFIED',
  },
  {
    label: t('widgets.measured'),
    value: 'MEASURED',
  },
  {
    label: t('widgets.estimated'),
    value: 'ESTIMATED',
  },
];

const roleMapper = {
  ENERGY_COMMUNITY_ADMIN: 'cer_admin',
  ENERGY_COMMUNITY_MANAGER: 'config_admin',
  ENERGY_COMMUNITY_MEMBER: 'member',
  EC_DASHBOARD_VIEW_ADMIN: 'cer_admin_view',
  EC_DASHBOARD_VIEW_MANAGER: 'config_admin_view',
  EC_DASHBOARD_VIEW_MEMBER: 'member_view',
};

export const findRole = (ecObj, grants) => {
// qui cerchiamo il grant relativo alla ec selezionata e ritorniamo il userType in base al grant corrispondente
// se il primo grant torna un user di tipo VIEW, allora ritorniamo sempre quel ruolo per ogni ec
// partiamo con il primo livello della ec selezionata, quindi cerchiamo il egId corrispondente all'ecId di quella ec
// se non troviamo nulla, allora proviamo con il secondo livello, cioè per ogni configurazione di quella ec cerchiamo il egId corrispondente all'ecId di quella configurazione
// se non troviamo nulla, allora proviamo con il terzo livello, cioè per ogni pod di ogni configurazione di quella ec cerchiamo il egId corrispondente all'ecId di quel pod
// se non troviamo nulla, allora non abbiamo nessun ruolo per quella ec e lanciamo un errore
  let grantToUse = null;
  if (Array.isArray(grants) && grants.length > 0) {
    if (grants[0].egId.includes('VIEW')) {
      return roleMapper[grants[0].roleName];
    }
    for (let i = 0; i < grants.length; i++) {
      const grant = grants[i];

      if (grant) {
        if (grant.egId === ecObj?.ecId) {
          grantToUse = grant;
          break;
        } else if (
          !grantToUse
        && ecObj?.configurations
        && ecObj?.configurations.some((conf) => conf.ecId === grant?.egId)
        ) {
          grantToUse = grant;
          break;
        } else if (
          !grantToUse
        && ecObj?.configurations
        && ecObj?.configurations.some((conf) => (conf.loadAreas
          ? conf.loadAreas.some((pod) => pod.ecId === grant?.egId)
          : false))
        ) {
          grantToUse = grant;
          break;
        }
      }
    }
  }

  if (grantToUse) {
    return roleMapper[grantToUse.roleName];
  }
  throw new NotAuthorizedError('Not authorized', {
    reason: 'No user role found',
  });
};
